module.exports = __webpack_public_path__ + "static/media/move-demo.b55487e3.mp4";